<template>
  <div class="loading-container">
    <div id="loader-wrapper">
      <div id="loader"></div>
    </div>
    <div class="loader">
      <div>L</div>
      <div>O</div>
      <div>A</div>
      <div>D</div>
      <div>I</div>
      <div>N</div>
      <div>G</div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<script>
import { useLoginStatus } from '@/hooks/sys'
import { useWxLogin } from '@/hooks/login'
import { useRoute, useRouter } from 'vue-router'
import { useQueryParams, useSystemInit } from '@/hooks'
import storage from '@/common/storage'
import { checkCorp, logout } from '@/apis'
export default {
  name: 'start',
  setup() {
    const router = useRouter()
    const route = useRoute()
    const { getLoginStatus } = useLoginStatus()
    //从企业微信进来,先退出后登录
    if (storage.token) {
      logout().then(() => {
        localStorage.clear()
        sessionStorage.clear()
      })
    }

    ;(async () => {
      const { corpId } = useQueryParams()
      const { data } = await checkCorp(corpId)
      const isLogin = await getLoginStatus()
      if (isLogin && data) {
        await useSystemInit()
        router.replace('/home')
      } else {
        const { doLogin } = useWxLogin()
        doLogin(async () => {
          await useSystemInit()
          const redirect = route.query.redirect || ''
          if (redirect) {
            router.replace(decodeURIComponent(redirect))
          } else {
            // 这里因为扫码登录或者企业微信登录等
            // router.replace('/home')
            location.href = '/micro-base-interior/#/home'
          }
        })
      }
    })()
    return {}
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
